/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-named-as-default */
import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import FSBModal from 'components/common/FSBModal';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import { useQuery } from '@apollo/client';
import { RiAddFill } from 'react-icons/ri';
import { cloneDeep, isEmpty } from 'lodash';
import { FSBTable } from 'components/common/FSBTable';
import {
  GRADES_REQUEST,
  GRADES_REQUEST_SUBSCRIPTION,
} from 'pages/Products/ProductsGraphQL';
import {
  USER_ID,
  defaultDeleteFilter,
  showSequenceNumber,
} from 'utils/constants';
import { useDispatch } from 'react-redux';
import { categoryGradeColumns } from 'pages/Products/constant';
import { setUserDetails } from 'actions/userDetailsAction';
import CategoryGradeDetails from '../CategoryGradeDetails';
import AddEditCategoryGrade from '../AddEditCategoryGrade';

const defaultFilters = {
  filter: [{ key: 'subCategory', value: '0', type: 'INT', op: 'EQ' }],
  pageNo: 1,
  pageSize: 10,
};
const CategoryGradeTable = ({ currentRowData }) => {
  const dispatch = useDispatch();
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [showAddRecord, setAddRecord] = useState(false);

  const toggleAddRecord = () => {
    setAddRecord(!showAddRecord);
  };
  const [filters, setFilters] = useState({
    ...defaultFilters,
    filter: [
      { key: 'subCategory', value: currentRowData.id, type: 'INT', op: 'EQ' },
      { ...defaultDeleteFilter },
    ],
  });
  const [showCategoryGradeDetails, setShowCategoryGradeDetails] = useState({
    status: false,
    row: '',
  });

  const toggleShowDetails = (row) => {
    setShowCategoryGradeDetails({
      status: !showCategoryGradeDetails.status,
      row,
    });
  };
  const { data, loading, error, subscribeToMore } = useQuery(GRADES_REQUEST, {
    variables: filters,
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');

    const unsubscribe = subscribeToMore({
      document: GRADES_REQUEST_SUBSCRIPTION,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.grades.grades.findIndex(
          (val) => val.id === subscriptionData.data.grades.grade.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (subscriptionData.data.grades.action === 'CREATED') {
          const newGrades = subscriptionData.data.grades.grade;
          const updatedGrades = [newGrades, ...newData.grades.grades];

          const newTotalCount = prev.grades.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.grades = {
            ...newData.grades,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            grades: updatedGrades,
          };
        }
        if (subscriptionData.data.grades.action === 'UPDATED') {
          newData.grades.grades[indexFound] =
            subscriptionData.data.grades.grade;
        }

        if (subscriptionData.data.grades.action === 'DELETED') {
          const { id } = subscriptionData.data.grades.grade; // ID of the grade to remove
          const prevGrades = prev.grades.grades;

          const updatedGrades = prevGrades.filter((val) => val.id !== id);

          const newTotalCount = prev.grades.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedGradesData = {
            ...newData.grades,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            grades: updatedGrades,
          };
          newData.grades = updatedGradesData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  const toggleDeleteRecord = () => {
    setDeleteRecord(!showDeleteRecord);
  };

  const onDeleteConfirmation = () => {
    // await deleteUser({
    //   variables: {
    //     id: id ? [id] : rowId,
    //     email: email ? [email] : rowEmail,
    //   },
    // });

    setDeleteRecord(false);
  };

  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };
  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo,
      pageSize,
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  if (error) return `There is an error on this page : ${error.message} `;

  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() => toggleShowDetails(cell?.row?.original)}
        aria-hidden
      >
        {cell?.row?.original?.name}
      </div>
    );
  };

  const handleUserId = (row, id) => {
    dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
  };

  const linkFormatterForUserId = (cell, userId) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() =>
          handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
        }
        aria-hidden
      >
        {cell?.row?.original?.[userId]}
      </div>
    );
  };

  const findIndexOfItem = (item) => {
    return categoryGradeColumns.findIndex((itm) => itm.accessorKey === item);
  };
  categoryGradeColumns[findIndexOfItem('name')].cell = linkFormatter;
  categoryGradeColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);
  categoryGradeColumns[findIndexOfItem(USER_ID.CREATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.CREATED_ID);
  categoryGradeColumns[findIndexOfItem(USER_ID.UPDATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.UPDATED_ID);

  return (
    <>
      <FSBModal
        title="Add Grade"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showAddRecord}
        toggleAlert={toggleAddRecord}
        onClose={toggleAddRecord}
        modalClass="right-drawer grade-drawer"
      >
        <AddEditCategoryGrade
          toggleAddRecord={toggleAddRecord}
          categoryId={currentRowData.id}
          type={showAddRecord.type}
        />
      </FSBModal>
      <FSBModal
        size="xl"
        title="Category Grade Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showCategoryGradeDetails.status}
        toggleAlert={toggleShowDetails}
        onClose={toggleShowDetails}
        modalClass="right-drawer right-drawer-details"
      >
        <CategoryGradeDetails
          categoryGradeDetails={showCategoryGradeDetails.row}
        />
      </FSBModal>

      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />

      <Card className="border-0 card-box">
        <CardHeader className="d-flex pt-2 bg-white gray-border align-items-center justify-content-between">
          <h4 className="f-16 mb-0 fw-semibold">Product</h4>
          <Button color="primary" size="sm" onClick={toggleAddRecord}>
            Add Grade <RiAddFill size={20} />
          </Button>
        </CardHeader>
        <CardBody className="pt-2">
          <FSBTable
            data={(data && data?.grades?.grades) || []}
            totalCount={(data && data?.grades?.totalCount) || 0}
            totalPages={(data && data?.grades?.totalPages) || 0}
            columns={categoryGradeColumns}
            currentPageNo={filters.pageNo}
            pageSize={filters.pageSize}
            keyField="id"
            search={false}
            pagination
            remote
            loading={loading}
            isDelete
            isFilter
            striped={false}
            hover={false}
            bordered={false}
            wrapperClass="table-responsive word-break"
            handlePageChange={handlePageChange}
            // globalSearchStr={filters.filter[0].value}
            // onGlobalSearch={onGlobalSearch}
            onSortChange={onSortChange}
            sorting={sortBy}
            // currentPageNo={filters.currentPage}
            // onRowClick={onRowClick}
          />
        </CardBody>
      </Card>
    </>
  );
};
export default CategoryGradeTable;
